const JOUR_MS = 86_400_000;

const isoToUtc = (iso) => Date.parse(`${iso.slice(0, 10)}T00:00:00Z`);
const utcToIso = (ms) => new Date(ms).toISOString().slice(0, 10);

// Renvoie [{ debut, finExclusive }] (dates ISO), ou null si le lot n'est pas planifié.
export function buildLotSegments(lot, taches) {
  if (!lot.date_debut_prevue || lot.duree_jours === null || lot.duree_jours === undefined) return null;

  const lotDebut = isoToUtc(lot.date_debut_prevue);
  const lotFin = lotDebut + Math.max(lot.duree_jours, 1) * JOUR_MS;
  if (!Number.isFinite(lotDebut)) return null;

  const prolongations = taches
    .filter((t) => t.lot_id === lot.id && !!t.start_date && !!t.target_date)
    .map((t) => ({ debut: isoToUtc(t.start_date), fin: isoToUtc(t.target_date) + JOUR_MS }))
    .filter(({ debut, fin }) => Number.isFinite(debut) && Number.isFinite(fin) && fin > debut)
    .filter(({ debut, fin }) => debut >= lotDebut && fin > lotFin)
    .sort((a, b) => a.debut - b.debut);

  const segments = [{ debut: lotDebut, fin: lotFin }];
  for (const prolongation of prolongations) {
    const dernier = segments[segments.length - 1];
    if (prolongation.debut <= dernier.fin) {
      dernier.fin = Math.max(dernier.fin, prolongation.fin);
    } else {
      segments.push({ ...prolongation });
    }
  }

  return segments.map(({ debut, fin }) => ({ debut: utcToIso(debut), finExclusive: utcToIso(fin) }));
}

export function derniereFinExclusive(segments) {
  return segments[segments.length - 1].finExclusive;
}

export function finInclusive(segment) {
  return utcToIso(isoToUtc(segment.finExclusive) - JOUR_MS);
}
